import { FeatureLogger } from "../utils/feature-logger";

const name = "call-tracking-metrics";

export const logger = new FeatureLogger(name);
